import React from 'react'
import PropTypes from 'prop-types'
import { Radio, Button } from '../../../components'
import { X } from 'react-feather'

const ReportPopup = ({title, onClose}) => {
  const [form, setForm] = React.useState({
    language: 'english'
  })

  const updateForm = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  const handleClose = (e) => {
    e.preventDefault()
    e.stopPropagation()

    onClose(false)
  }

  return (
    <div
      className="fixed left-0 top-0 w-full h-screen flex justify-center items-center"
      style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)'}}
      onClick={handleClose}
    >
      <div className="container mx-auto" onClick={(e) => e.stopPropagation()}>
        <div className="lg:w-5/12 mx-auto p-5 lg:p-8 bg-white rounded overflow-y-auto" style={{maxHeight: '100vh'}}>
          <div className="flex items-center justify-between lg:block mb-4 lg:mb-5">
            <p className="text-lg lg:text-2xl font-bold">Download Final Report</p>
            <X className="lg:hidden" onClick={handleClose} width={18} height={18}/>
          </div>
          <hr className="mb-8"/>
          <div className="mb-8">
            <Radio
              name="language"
              id="language1"
              label={`${title} Final Report - English Version`}
              value="english"
              className="mr-4 mb-2"
              form={form}
              onChange={updateForm}
            />
            <Radio
              name="language"
              id="language2"
              label={`${title} Final Report - Indonesia Version`}
              value="indonesia"
              form={form}
              onChange={updateForm}
            />
          </div>
          <Button className="hidden md:block" onClick={handleClose}>Download</Button>
          <Button className="md:hidden" thin onClick={handleClose}>Download</Button>
        </div>
      </div>
    </div>
  )
}

ReportPopup.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func,
}

ReportPopup.defaultProps = {
  title: 'Breaking Down the Walls',
  onClose: () => {},
}

export { ReportPopup }
